import React from "react";
import { formatBook } from "../../../utils/formatOdds";

// Fallback labels when the feed has no rows yet (API sub order: 0, 1, 2, 4, 6 Runs, Wicket)
const LABELS = ["0 Runs", "1 Runs", "2 Runs", "4 Runs", "6 Runs", "Wicket"];

/** Reference v-kval: 1000+ -> K (1 decimal, trailing zeros dropped) */
function formatSize(value) {
  const n = Number(value) || 0;
  return n >= 1e3 ? `${parseFloat((n / 1e3).toFixed(1))}K` : String(parseFloat(n));
}

/** Reference v-kvalpoint: 1000+ -> K (2 decimals, trailing zeros dropped) */
function formatLimit(value) {
  const n = Number(value) || 0;
  return n >= 1e3 ? `${parseFloat((n / 1e3).toFixed(2))}K` : String(parseFloat(n));
}

function getExposure(exposures, nat) {
  if (!nat) return 0;
  const v = exposures[nat] ?? exposures[nat.toLowerCase()] ?? exposures[nat.trim()] ?? 0;
  return Number(v) || 0;
}

/**
 * Lucky 15 "Runs" market — reference Market6 markup (casino/lucky15):
 * .market-6 > .bet-table > header "Runs" + body (Back titles row, then one col-6 col-md-4 per run).
 * Display only (no bet slip on the admin page), as before.
 */
export default function BetTableLucky15({ data, exposures = {} }) {
  const sub = Array.isArray(data) && data.length ? data : LABELS.map((nat) => ({ nat, b: 0, gstatus: "SUSPENDED" }));

  return (
    <div className="market-6">
      <div className="bet-table">
        <div data-toggle="collapse" data-target="#market-runs" aria-expanded="true" className="bet-table-header">
          <div className="nation-name">
            <span title="Runs">Runs</span>
          </div>
        </div>{" "}
        <div id="market-runs" className="bet-table-body collapse show container-fluid container-fluid-5">
          <div className="row row5 d-none-mobile">
            {[0, 1, 2].map((i) => (
              <React.Fragment key={i}>
                {i > 0 && " "}
                <div className="col-6 col-md-4">
                  <div className="fancy-tripple">
                    <div className="bet-table-row">
                      <div className="nation-name" />{" "}
                      <div className="back bl-title back-title">Back</div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>{" "}
          <div className="row row5">
            {sub.map((s, i) => {
              const exp = getExposure(exposures, s?.nat);
              const noVal = Number(s?.b) === 0 || s?.b == null;
              const suspended = s?.gstatus !== "OPEN";
              const cls = `bl-box back${noVal ? " no-val" : ""}${suspended ? " suspended" : ""}`;
              return (
                <div key={`web${i}`} className="col-6 col-md-4">
                  <div className="fancy-tripple">
                    <div className="bet-table-row">
                      <div className="nation-name d-none-mobile">
                        <p>{s?.nat}</p>{" "}
                        <p className={`mb-0 ${exp > 0 ? "book-green" : "book-red"}`}>
                          {formatBook(exp)}
                        </p>
                      </div>{" "}
                      <div data-title={s?.gstatus} className={cls}>
                        <span className="d-block odds">{noVal ? "—" : s.b}</span>{" "}
                        {Number(s?.bs) !== 0 && !noVal && s?.bs != null ? (
                          <span className="d-block">{formatSize(s.bs)}</span>
                        ) : null}
                      </div>{" "}
                      <div className="fancy-min-max">
                        Min:<span>{formatLimit(s?.min)}</span> Max:<span>{formatLimit(s?.max)}</span>
                      </div>
                    </div>{" "}
                    {s?.rem && s.rem !== "" ? <div className="market-message">{s.rem}</div> : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
